// The M® Note's amount, fitted to its face.
//
// app 1.4.7 (Alexander, 15 Oct) — the amount is 25 % smaller than 1.4.6's (33.6 → 25.2 px), and its size is
// set by the short amounts: "$1.50" fixes the box (25.2 px, line-height 1). A longer amount shrinks in
// proportion — font size × the room there is ÷ the width it would take — so "$15,000", "$1,000,000" and
// anything longer sit on one line beside M® NOTE / BACKED 1:1 BY USDC ON ARC, which never wraps. (1.4.6 had
// three fixed sizes by character count.) The link preview's picture does the same sum
// (functions/_lib/noteOg.ts, scripts/note-og/build.py).

export const AMT_PX = 25.2; // the face's amount (CSS px on the Take page's 308 px face) — home21.css .mn-amt
export const AMT_GAP = 12; // the least room between the words on the left and the amount

/** Fit every note amount under `root` to the room beside the words on its left. */
export function fitAmounts(root: ParentNode = document): void {
  for (const amt of root.querySelectorAll<HTMLElement>(".mnote-sm .mn-amt")) {
    const top = amt.parentElement;
    const den = top?.querySelector<HTMLElement>(".mn-den");
    if (!top || !den) continue;
    amt.style.fontSize = "";
    const room = top.clientWidth - den.getBoundingClientRect().width - AMT_GAP;
    const w = amt.getBoundingClientRect().width;
    if (room > 0 && w > room) amt.style.fontSize = `${((parseFloat(getComputedStyle(amt).fontSize) * room) / w).toFixed(2)}px`;
  }
}

let watching = false;
/**
 * Keep every face's amount fitted: when a face appears (the views set innerHTML), when the fonts arrive
 * (the serif's widths differ from the fallback's), and when the window changes size. Once per page.
 */
export function watchAmounts(): void {
  if (watching || typeof document === "undefined") return;
  watching = true;
  let queued = false;
  const soon = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      fitAmounts();
    });
  };
  new MutationObserver((records) => {
    for (const r of records) {
      for (const n of r.addedNodes) {
        if (n instanceof Element && (n.matches(".mn-amt, .mnote-sm") || n.querySelector(".mn-amt"))) return soon();
        if (n.nodeType === Node.TEXT_NODE && n.parentElement?.closest(".mn-amt")) return soon();
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
  document.fonts?.ready.then(soon).catch(() => undefined);
  window.addEventListener("resize", soon);
  soon();
}
